// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goodsAnalyze[data-v-5b2c299e] {\n  padding: 10px 20px 0 20px;\n  margin: 0 3px;\n  height: 100%;\n  background-color: white;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.goodsAnalyze__body[data-v-5b2c299e] {\n  overflow: hidden;\n  flex-direction: column;\n  display: flex;\n  height: 100%;\n}\n.goodsAnalyze__body div[data-v-5b2c299e] {\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
